import { deepMerge } from '../utils/common';
/**
 * 运营商
 */
export const Operator = {
  1: '移动',
  2: '联通',
  3: '电信CDMA',
};

/**
 * 内容类型
 */
export const MSG_CONTENT_TYPE = {
  IMAGE_TEXT: 1, // 图文 | 邮件
  TEXT: 2, // 文字
  IMAGE: 3, // 图片
  VIDEO: 4, // 视频
  AUDIO: 5, // 语音
};

/* 贴片类型 */
export const PATCHTYPES = [{ label: '文本', value: '1', checked: false }, { label: '语音文本', value: '2', checked: false }, { label: '图片', value: '3', checked: false }];

/**
 * 消息类型常量及相关方法
 * MO-上行消息
 * MT-消息下行
 * 定义规则：type值从小到大
 */
export const _MSGTYPES = {
  MO: {
    SMS: {
      type: 0,
      name: '短信',
      icon: 'assets/images/msgType/sms.png',
    },
    VOICE: {
      type: 4,
      name: '语音',
      icon: 'assets/images/msgType/voice.png',
    },
    WECHAT: {
      type: 5,
      name: '微信',
      icon: 'assets/images/msgType/wchat.png',
    },
    EMAIL: {
      type: 6,
      name: '邮件',
      icon: 'assets/images/msgType/mail.png',
    },
    WORKWX: {
      type: 8,
      name: '企业微信',
      icon: 'assets/images/msgType/workwx.png',
    },
    _5G: {
      type: 9,
      name: '5G消息',
      icon: 'assets/images/msgType/_5g.png',
    },
    TIKTOK: {
      type: 7,
      name: '抖音',
      icon: 'assets/images/msgType/tiktok.png',
    },
  },
  MT: {
    SMS: {
      type: 0,
      name: '短信',
      key: 'sms', // 添加该字段-权限后缀动态判断
      icon: 'assets/images/msgType/sms.png',
      icon_gray: 'assets/images/msgType/sms_gray.png',
      patchTypes: '1', // 添加该字段-对应的贴片类型 1 文本  2 语音文本  3 图片
      autoReport: 1, //  添加该字段-是否支持自动上报  0 否  1 是
      autoReply: 1, // 添加该字段-是否支持消息自动化引擎-自动回复  0 否  1 是
      channelProvider: 1, //  添加该字段-是否可以渠道商管理  0 否  1 是
      channel: 1,  // 添加该字段-是否可以渠道管理 0 否 1是
      moRecord: 1,  // 添加字段-是否显示上行消息
    },
    MMS: {
      type: 1,
      name: '彩信',
      key: 'mms',
      icon: 'assets/images/msgType/sms.png',
      icon_gray: 'assets/images/msgType/sms_gray.png',
      patchTypes: '',
      autoReport: 1,
      autoReply: 0,
      channelProvider: 1,
      channel: 0,
      moRecord: 0,
    },
    WECHAT: {
      type: 2,
      name: '微信',
      key: 'wechat',
      icon: 'assets/images/msgType/wchat.png',
      icon_gray: 'assets/images/msgType/wchat_gray.png',
      patchTypes: '1',
      autoReport: 1,
      autoReply: 1,
      channelProvider: 0,
      channel: 1,
      moRecord: 1,
    },
    VOICE: {
      type: 3,
      name: '语音',
      key: 'voice',
      icon: 'assets/images/msgType/voice.png',
      icon_gray: 'assets/images/msgType/voice_gray.png',
      patchTypes: '2',
      autoReport: 0,
      autoReply: 0,
      channelProvider: 1,
      channel: 1,
      moRecord: 1,
    },
    EMAIL: {
      type: 4,
      name: '邮件',
      key: 'email',
      icon: 'assets/images/msgType/mail.png',
      icon_gray: 'assets/images/msgType/mail_gray.png',
      patchTypes: '1,3',
      autoReport: 1,
      autoReply: 1,
      channelProvider: 1,
      channel: 1,
      moRecord: 1,
    },
    WEIBO: {
      type: 5,
      name: '微博',
      key: 'weibo',
      icon: 'assets/images/msgType/weibo.png',
      icon_gray: 'assets/images/msgType/weibo_gray.png',
      patchTypes: '',
      autoReport: 1,
      autoReply: 0,
      channelProvider: 1,
      channel: 0,
      moRecord: 0,
    },
    JPUSH: {
      type: 6,
      name: '极光推送',
      key: 'jpush',
      icon: 'assets/images/msgType/jpush.png',
      icon_gray: 'assets/images/msgType/jpush_gray.png',
      patchTypes: '1',
      autoReport: 0,
      autoReply: 0,
      channelProvider: 0,
      channel: 1,
      moRecord: 0,
    },
    TIKTOK: {
      type: 7,
      name: '抖音',
      key: 'tiktok',
      icon: 'assets/images/msgType/tiktok.png',
      icon_gray: 'assets/images/msgType/tiktok_gray.png',
      patchTypes: '',
      autoReport: 0,
      channelProvider: 0,
      channel: 1,
      moRecord: 0,
    },
    WORKWX: {
      type: 8,
      name: '企业微信',
      key: 'workwx',
      icon: 'assets/images/msgType/workwx.png',
      icon_gray: 'assets/images/msgType/workwx_gray.png',
      patchTypes: '',
      autoReport: 0,
      autoReply: 1,
      channelProvider: 0,
      channel: 1,
      moRecord: 1,
    },
    _5G: {
      type: 9,
      name: '5G消息',
      key: '5g',
      icon: 'assets/images/msgType/_5g.png',
      icon_gray: 'assets/images/msgType/_5g_gray.png',
      patchTypes: '',
      autoReport: 0,
      autoReply: 1,
      channelProvider: 1,
      channel: 1,
      moRecord: 1,
    },
  },
  getMsgList,
  getMsgListByTypes,
  getMsgNamesByTypes,
  getMsgByType,
  getMsgByName,
  getMsgTplOptions,
};
/**
 * 获取上/下行所有的消息类型的数组
 * @param isMo 是否为上行消息
 * @returns [...{type: 0, name: '短信'}]
 */
function getMsgList(isMo?) {
  let selectObject = isMo ? this.MO : this.MT;
  let resultArray = [];
  for (const key in selectObject) {
    if (selectObject.hasOwnProperty(key)) {
      resultArray.push(selectObject[key]);
    }
  }
  return resultArray;
}
/**
 * 传入不确定个数的消息类型，返回对应消息类型的数组
 * @param isMo 是否为上行消息
 * @param msgTypes  消息类型
 * @returns [...{type: 0, name: '短信'}]
 */
function getMsgListByTypes(isMo, ...msgTypes) {
  let selectObject = isMo ? this.MO : this.MT;
  let resultArray = [];
  for (const key in selectObject) {
    if (selectObject.hasOwnProperty(key)) {
      msgTypes.forEach(type => {
        if (type === selectObject[key].type) {
          resultArray.push(selectObject[key]);
        }
      });
    }
  }
  return resultArray;
}
/**
 * 传入含有多个消息类型的字符串，返回对应消息类型的名称字符串
 * @param isMo 是否为上行消息
 * @param msgTypes  消息类型
 * @param separator 消息类型字符串的分隔符，默认为逗号
 * @returns '短信,语音,...'
 */
function getMsgNamesByTypes(isMo, msgTypes, separator?) {
  let selectObject = isMo ? this.MO : this.MT;
  const _separator = separator ? separator : ',';
  let typeList = msgTypes.split(separator ? separator : ',').filter(str => str !== '');
  let result = '';
  for (const key in selectObject) {
    if (selectObject.hasOwnProperty(key)) {
      typeList.forEach(typeStr => {
        if (Number(typeStr) === selectObject[key].type) {
          result += ',' + selectObject[key].name;
        }
      });
    }
  }
  if (result.charAt(0) === ',') {
    result = result.slice(1);
  }
  return result;
}
/**
 * 通过类型获取消息类型的对象
 * @param isMo 是否为上行消息
 * @param msgType  消息类型
 * @returns 消息类型对象 {type: -, name: -}
 */
function getMsgByType(isMo, msgType) {
  let selectObject = isMo ? this.MO : this.MT;
  let result: any = {};
  for (const key in selectObject) {
    if (selectObject.hasOwnProperty(key)) {
      if (selectObject[key].type === msgType) {
        result = selectObject[key];
      }
    }
  }
  return result;
}
/**
 * 获取消息类型的对象
 * @param isMo 是否为上行消息
 * @param msgName  消息类型的名称
 * @returns 消息类型对象 {type: -, name: -}
 */
function getMsgByName(isMo, msgName) {
  let selectObject = isMo ? this.MO : this.MT;
  let result = {};
  for (const key in selectObject) {
    if (selectObject.hasOwnProperty(key)) {
      const item = selectObject[key];
      if (selectObject[key].name === msgName) {
        result = selectObject[key];
      }
    }
  }
  return result;
}

/* 注意：formTplComps仅用于自动匹配模板时，动态创建的配置 */
const formTplComps = {
  textarea: {
    type: 'textarea',
    require: true,
    maxlength: 500,
    disabled: true,
    config: {
      value: '',
      isHasTemplate: true,
      templateList: [], // 自动匹配模板时，以此遍历显示模板内容
    },
  },
  'icc-video': {
    type: 'icc-video',
    config: {
      url: '',
      isHasTemplate: true,
      templateName: '',
      disabled: true,
    },
  },
  'icc-image-upload': {
    type: 'icc-image-upload',
    config: {
      editable: false,
      isHasTemplate: true,
      templateName: '',
      imgList: [],
    },
  },
  'icc-audio-upload': {
    type: 'icc-audio-upload',
    config: {
      fileUrl: '', // 音频文件路径
      isHasTemplate: true,
      templateName: '',
    },
  },
  'email-picker': {
    input: {
      type: 'input',
      label: '主题',
      labelWidth: 56,
      require: true,
      placeholder: '',
      maxlength: 50,
      disabled: true,
      config: {
        value: '',
        isHasTemplate: true,
        templateName: '',
      },
    },
    editor: {
      type: 'editor',
      label: '内容',
      labelWidth: 56,
      require: true,
      placeholder: '',
      disabled: true,
      config: {
        isHasTemplate: true,
        value: '',
      },
    },
  },
};
const msgTplOptions = {
  autoMatch: [
    // 由于看到很多类型的自动匹配显示都是多行文本的遍历，故提出来作为一种单独配置来切换
    {
      form: [
        {
          type: 'textarea',
          require: true,
          maxlength: 500,
          disabled: true,
          config: {
            value: '',
            isHasTemplate: false,
            templateList: [], // 自动匹配模板时，以此遍历显示模板内容
            extraTag: {
              list: [],
              nzMode: 'default',
              isHasSegment: true,
              segments: 0,
            },
          },
        },
      ],
    },
  ],
  sms: [
    {
      form: [
        {
          type: 'textarea',
          require: true,
          maxlength: 500,
          placeholder: '请输入短信内容',
          disabled: false,
          config: {
            value: '',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
            isHasTemplate: false,
            extraTag: {
              list: [],
              nzMode: 'default',
              isHasSegment: true,
              segments: 0,
            },
          },
        },
      ],
    },
  ],
  voice: [
    {
      form: [
        {
          type: 'textarea',
          require: true,
          maxlength: 500,
          placeholder: '请输入语音内容',
          disabled: true,
          config: {
            value: '',
            isHasTemplate: false,
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
          },
        },
      ],
    },
  ],
  wechat: [
    {
      title: '图文',
      contentType: 1,
      active: true,
      guide: {
        type: 'icc-side-menu',
        width: 255,
        config: {
          readonly: false,
          header: {
            iconUrl: 'https://iconfont.alicdn.com/t/1530157532420.jpg@100h_100w.jpg',
            title: 'sungf',
          },
          list: [],
          selectedItem: null,
          events: [
            {
              id: 1,
              name: '写新图文',
              icon: 'edit',
            },
          ],
        },
      },
      useGuideIndex: true, // 当左侧guide的内容需要在右侧form展示时，则为true，此时form中的双向绑定字段使用index指定的字段， 默认为false
      form: [
        {
          type: 'input',
          label: '标题',
          labelWidth: 56,
          require: true,
          placeholder: '请输入标题',
          maxlength: 50,
          disabled: false,
          config: {
            index: 'title',
          },
        },
        {
          type: 'input',
          label: '作者',
          labelWidth: 56,
          require: true,
          placeholder: '请输入作者',
          maxlength: 50,
          disabled: false,
          config: {
            index: 'author',
          },
        },
        {
          type: 'editor',
          require: true,
          placeholder: '请输入正文',
          disabled: false,
          config: {
            index: 'content',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
          },
        },
        {
          type: 'nz-upload',
          width: '112px',
          require: true,
          config: {
            index: 'coverList',
          },
        },
        {
          type: 'textarea',
          width: 'calc(100% - 112px)',
          require: false,
          placeholder: '请输入摘要（选填）',
          maxlength: 120,
          disabled: false,
          config: {
            index: 'summary',
            isHasTemplate: false,
            templateName: '',
            height: 104,
          },
        },
      ],
    },
    {
      title: '文字',
      contentType: 2,
      form: [
        {
          type: 'textarea',
          require: true,
          placeholder: '请输入文本内容',
          config: {
            value: '',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
          },
        },
      ],
    },
    {
      title: '图片',
      contentType: 3,
      form: [
        {
          type: 'nz-upload',
          width: '112px',
          require: true,
          config: {
            nzFileList: [],
          },
        },
      ],
    },
  ],
  email: [
    {
      form: [
        {
          type: 'input',
          label: '主题',
          labelWidth: 56,
          require: true,
          placeholder: '请输入邮件主题',
          maxlength: 50,
          disabled: false,
          config: {
            value: '',
          },
        },
        {
          type: 'editor',
          label: '内容',
          labelWidth: 56,
          require: true,
          placeholder: '请输入邮件内容',
          disabled: false,
          config: {
            value: '',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
            extraTag: {
              list: [],
              nzMode: 'default',
              isHasSegment: true,
              segments: 0,
            },
          },
        },
      ],
    },
  ],
  jpush: [
    {
      form: [
        {
          type: 'input',
          label: '标题',
          labelWidth: 56,
          require: true,
          placeholder: '请输入标题',
          maxlength: 50,
          disabled: false,
          config: {
            value: '',
          },
        },
        {
          type: 'textarea',
          label: '内容',
          labelWidth: 56,
          require: true,
          placeholder: '请输入极光推送内容',
          maxlength: 500,
          disabled: false,
          config: {
            value: '',
            isHasTemplate: false,
            templateName: '',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
            extraTag: {
              list: [],
              nzMode: 'default',
              isHasSegment: true,
              segments: 0,
            },
          },
        },
      ],
    },
  ],
  tiktok: [
    {
      form: [
        {
          type: 'input',
          label: '标题',
          labelWidth: 56,
          require: true,
          placeholder: '请输入标题',
          maxlength: 50,
          disabled: false,
          config: {
            value: '',
          },
        },
        {
          type: 'nz-tabset',
          activeIndex: 0,
          tabList: [
            {
              title: '视频',
              form: [
                {
                  type: 'icc-video',
                  config: {
                    req: '',
                    url: '',
                    disabled: false,
                    success: null,
                    videoRemove: null,
                  },
                },
              ],
            },
            {
              title: '图片',
              form: [
                {
                  type: 'icc-image-upload',
                  config: {
                    editable: true,
                    imgList: [],
                    maxSize: 10,
                    maxCount: 1,
                    success: null,
                    remove: null,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  workwx: [
    {
      title: '图文',
      contentType: 1,
      active: true,
      guide: {
        type: 'icc-side-menu',
        width: 255,
        config: {
          readonly: false,
          header: {
            iconUrl: 'https://iconfont.alicdn.com/t/1530157532420.jpg@100h_100w.jpg',
            title: 'sungf',
          },
          list: [],
          selectedItem: null,
          events: [
            {
              id: 1,
              name: '写新图文',
              icon: 'edit',
            },
          ],
        },
      },
      useGuideIndex: true, // 当左侧guide的内容需要在右侧form展示时，则为true，此时form中的双向绑定字段使用index指定的字段， 默认为false
      form: [
        {
          type: 'input',
          label: '标题',
          labelWidth: 56,
          require: true,
          placeholder: '请输入标题',
          maxlength: 50,
          disabled: false,
          config: {
            index: 'title',
          },
        },
        {
          type: 'input',
          label: '作者',
          labelWidth: 56,
          require: true,
          placeholder: '请输入作者',
          maxlength: 50,
          disabled: false,
          config: {
            index: 'author',
          },
        },
        {
          type: 'editor',
          require: true,
          placeholder: '请输入正文',
          disabled: false,
          config: {
            index: 'content',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
          },
        },
        {
          type: 'nz-upload',
          width: '112px',
          require: true,
          config: {
            index: 'coverList',
          },
        },
        {
          type: 'textarea',
          width: 'calc(100% - 112px)',
          require: false,
          placeholder: '请输入摘要（选填）',
          maxlength: 120,
          disabled: false,
          config: {
            index: 'summary',
            isHasTemplate: false,
            templateName: '',
            height: 104,
          },
        },
      ],
    },
    {
      title: '文字',
      contentType: 2,
      form: [
        {
          type: 'textarea',
          require: true,
          placeholder: '请输入文本内容',
          config: {
            value: '',
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              console.log('aaa');
            }, // 贴片事件
          },
        },
      ],
    },
    {
      title: '图片',
      contentType: 3,
      form: [
        {
          type: 'nz-upload',
          width: '112px',
          require: true,
          config: {
            nzFileList: [],
          },
        },
      ],
    },
    {
      title: '视频',
      contentType: 4,
      form: [
        {
          type: 'icc-video',
          config: {
            req: '',
            url: '',
            size: 50,
            disabled: false,
            success: null,
            videoRemove: null,
          },
        },
      ],
    },
    {
      title: '语音',
      contentType: 5,
      form: [
        {
          type: 'icc-audio-upload',
          config: {
            nzAction: '', // 上传接口地址
            fileUrl: '', // 音频文件路径
            success: null,
            delete: null, // 音频文件删除时响应事件
          },
        },
      ],
    },
  ],
  _5g: [],
};
/**
 * 获取生成消息模板的初始配置
 * @param msgType  消息类型或自定义配置名
 * @param isMo  是否为上行消息,默认false
 * @returns 生成消息模板的初始配置
 */
export function getMsgTplOptions(msgType: any, isMo?: boolean) {
  const _msgConstant = {
    autoMatch: 'autoMatch',
    sms: _MSGTYPES.MT.SMS.type,
    wechat: _MSGTYPES.MT.WECHAT.type,
    wechatContent: 'wechat-content',
    voice: _MSGTYPES.MT.VOICE.type,
    email: _MSGTYPES.MT.EMAIL.type,
    jpush: _MSGTYPES.MT.JPUSH.type,
    tiktok: _MSGTYPES.MT.TIKTOK.type,
    workwx: _MSGTYPES.MT.WORKWX.type,
    _5g: _MSGTYPES.MT._5G.type,
  };
  let options: any;
  for (const key in _msgConstant) {
    if (_msgConstant.hasOwnProperty(key) && _msgConstant[key] === msgType) {
      options = deepMerge(msgTplOptions[key], null);
    }
  }
  return options;
}

/**
 * 通过组件类型获取对应组件的配置对象
 * @param tplOptions  模板配置
 * @param compType  组件类型
 * @returns 对应组件的配置对象
 */
export function getCompOptionsByType(tplOptions: any, compType: string) {
  let result = [];
  if (tplOptions instanceof Array) {
    tplOptions.forEach(tabOptions => {
      if (tabOptions.guide && tabOptions.guide.type === compType) {
        result.push(tabOptions.guide);
      }
      if (!tabOptions.form) return;
      const formComps = tabOptions.form;
      if (formComps instanceof Array) {
        formComps.forEach(compItem => {
          if (compItem.type === compType) {
            result.push(compItem);
          } else if ('nz-tabset' === compItem.type && compItem.tabList instanceof Array) {
            compItem.tabList.forEach(innerTab => {
              if (innerTab.form instanceof Array) {
                innerTab.form.forEach(innerComp => {
                  if (innerComp.type === compType) {
                    result.push(innerComp);
                  }
                });
              }
            });
          }
        });
      }
    });
  }
  return result;
}

/**
 * 通过组件类型动态生成配置对象
 * @param compTypeList  组件类型列表
 * @returns 生成的配置对象
 */
export function createSimpleOptionByCompTypes(compTypeList) {
  const options = [
    {
      form: [],
    },
  ];
  if (compTypeList instanceof Array) {
    compTypeList.forEach(compType => {
      switch (compType) {
        case 'textarea':
          // 注意，此处的对象需要深克隆
          options[0].form.push(deepMerge(formTplComps.textarea, null));
          break;
        case 'icc-video':
          options[0].form.push(deepMerge(formTplComps['icc-video'], null));
          break;
        case 'icc-image-upload':
          options[0].form.push(deepMerge(formTplComps['icc-image-upload'], null));
          break;
        case 'icc-audio-upload':
          options[0].form.push(deepMerge(formTplComps['icc-audio-upload'], null));
          break;
        case 'email-picker':
          for (const key in formTplComps['email-picker']) {
            if (formTplComps['email-picker'].hasOwnProperty(key)) {
              options[0].form.push(deepMerge(formTplComps['email-picker'][key], null));
            }
          }
          break;
        default:
          break;
      }
    });
  }
  return options;
}
